import { ClickEvent } from "devextreme/ui/button";
import { ToolbarItem } from "devextreme/ui/data_grid";

export class ToolbarItemFactory {
  static createButton(options: {
    icon?: string;
    text: string;
    onClick?: (event: ClickEvent) => void;
    location?: "before" | "after";
    type?: "default" | "danger" | "primary";
    stylingMode?: "text" | "contained";
  }): ToolbarItem {
    return {
      location: options.location || "before",
      widget: "dxButton",
      locateInMenu: "auto",
      options: {
        icon: options.icon,
        type: options.type,
        text: options.text,
        stylingMode: options.stylingMode || "text",
        onClick: options.onClick
      }
    };
  }

  static createSeparator(): ToolbarItem {
    return {
      visible: false,
      location: "before",
      locateInMenu: "never",
      template: (): string => {
        return `<div class="toolbar-separator">&nbsp;</div>`;
      }
    };
  }
}
